import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, orderPickupButtonMobile } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/5iy9tuDt9yipKnztgM8d/locations/B1AYIaz8ilTm730fykGj`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="320px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/5iy9tuDt9yipKnztgM8d/locations/B1AYIaz8ilTm730fykGj`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} w="280px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
